"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_LEVEL_ADR = void 0;
exports.BASE_LEVEL_ADR = 2;
